import React from 'react';

import { Accordion, type AccordionItem } from '../Accordion/Accordion';
import { useInView } from '../../hooks/useInView';

import './FaqSection.css';

export type Faq = {
    heading: string;
    items: AccordionItem[];
};

type FaqSectionProps = {
    data: Faq;
};

export function FaqSection({ data }: FaqSectionProps) {
    const [ref, inView] = useInView<HTMLDivElement>();

    return (
        <section className="faves-faq">
            <div
                ref={ref}
                className={`faves-faq__inner faves-reveal-group${inView ? ' faves-faq__inner--in-view faves-reveal-group--in' : ''}`}
            >
                <h2 className="faves-faq__heading faves-display faves-reveal">{data.heading}</h2>
                <Accordion
                    items={data.items}
                    classPrefix="faves-faq"
                    idPrefix="faves-faq"
                />
            </div>
        </section>
    );
}
